import { InspectionImage } from "../../../_objects/inspection-image";

export class PreviewImageDetail extends InspectionImage {
  width: number;
  height: number;
  isDummy: boolean;
  tenantId: string;
  measurementItems: any[];

  constructor(inspectionImage?: InspectionImage, width?: number, height?: number, isDummy?: boolean, tenantId?: string, measurementItems?: any[]) {
    super();
    if (inspectionImage) {
      this.id = inspectionImage.id;
      this.inspectionId = inspectionImage.inspectionId;
      this.subjectLocationId = inspectionImage.subjectLocationId;
      this.mimeType = inspectionImage.mimeType;
      this.imageType = inspectionImage.imageType;

      this.fileName = inspectionImage.fileName;
      this.filePath = inspectionImage.filePath;
      this.originalFilePath = inspectionImage.originalFilePath;
      this.modifiedFilePath = inspectionImage.modifiedFilePath;
      this.thumbFilePath = inspectionImage.thumbFilePath;
      this.imageDescription = inspectionImage.imageDescription;
      this.datetime = inspectionImage.datetime;
      this.orientation = inspectionImage.orientation;
      this.sortOrder = inspectionImage.sortOrder;
      this.comment = inspectionImage.comment;

      this.metadata = inspectionImage.metadata;
      this.permission = inspectionImage.permission;
      this.isDataPlate = inspectionImage.isDataPlate;
      this.usedImageMode = inspectionImage.usedImageMode;
      this.hasModifiedImage = inspectionImage.hasModifiedImage;

      this.schemaVersion = inspectionImage.schemaVersion;
      this.createdBy = inspectionImage.createdBy;
      this.createDate = inspectionImage.createDate;
      this.lastUpdatedBy = inspectionImage.lastUpdatedBy;
      this.lastUpdateDate = inspectionImage.lastUpdateDate;

      this.modifiedWidth = inspectionImage.modifiedWidth;
      this.modifiedHeight = inspectionImage.modifiedHeight;
    }

    this.setExtendProp(width, height, isDummy, tenantId, measurementItems);
  }

  setExtendProp(width: number, height: number, isDummy: boolean, tenantId: string, measurementItems: any[]) {
    this.width = width;
    this.height = height;
    this.isDummy = isDummy;
    this.tenantId = tenantId;
    this.measurementItems = measurementItems;
  }
}
